export const name = "KLL_QUANTILES.INIT_FLOAT64";
export const summary = `Aggregates values into a \`FLOAT64\`-initialized KLL sketch.`;
export const reference = `
## KLL_QUANTILES.INIT_FLOAT64

Aggregates values into a \`FLOAT64\`-initialized KLL sketch.

\`\`\`
KLL_QUANTILES.INIT_FLOAT64(input[, precision[, weight => input_weight]])
\`\`\`

### Description

Like \`KLL_QUANTILES.INIT_INT64\`, but accepts \`input\` of type \`FLOAT64\`.

\`KLL_QUANTILES.INIT_FLOAT64\` orders values according to the GoogleSQL floating point sort order. For example, \`NaN\` orders before\`‑inf\`.


### Supported Argument Types

- \`input\`: \`FLOAT64\`
- \`precision\`: \`INT64\`
- \`input_weight\`: \`INT64\`


### Return Type

KLL sketch as \`BYTES\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/kll_functions
`;
